// extracted by mini-css-extract-plugin
export default {"imgHeader":"Login_imgHeader__Jo364"};